<!-- PDFサムネイル表示コンポーネント(アップロードファイル用) -->
<template>
    <div class="pdf-document">
        <div :id="id" style="position: relative; height:260px;">
            <slot></slot>
            <v-overlay :absolute="true" :value="isLoading" :z-index=1>
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </div>
    </div>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist';
import "pdfjs-dist/web/pdf_viewer.css";

export default {
    props: [
        'file',
        'scale',
        'maxWidth',
        'suffixes'
    ],
    data() {
        return {
            isLoading: false,
            id: 'uploadFile_' + this.suffixes,
        };
    },
    created() {
        pdfjsLib.GlobalWorkerOptions.workerSrc = "/documents/js/pdf.worker.js";
    },
    async mounted() {
        this.setLoading(true);
        this.$emit('loading', true);

        var reader = new FileReader();
        var self = this;
        reader.onload = (function(reader) {
            return async function() {
                var contents = reader.result;
                // console.log(contents);
                // let loadingTask = pdfjsLib.getDocument(contents);
                let loadingTask = pdfjsLib.getDocument({
                    url: contents,
                    // cMapUrl: ./node_modules/pdfjs-dist/cmaps/,'
                    cMapUrl: '/documents/cmaps/',
                    cMapPacked: true,
                });
                let loadpdf = await loadingTask.promise;
        
                const page = await loadpdf.getPage(1);
                const viewport = page.getViewport({ scale: self.scale });
                var scale = Math.min((259 / viewport.height), (195 / viewport.width));
                var reViewport = page.getViewport({ scale: scale });

                const canvas = document.createElement('canvas');
                canvas.height = reViewport.height;
                canvas.width = reViewport.width;

                document.getElementById(self.id).appendChild(canvas);
                await page.render({
                    canvasContext: canvas.getContext('2d'),
                    viewport: reViewport
                }).promise;
                
                self.setLoading(false);
            };
        })(reader);
        reader.readAsDataURL(this.file);
    },
    methods: {
        setLoading: function (loading) {
            this.isLoading = loading;
        },
    }
};
</script>

<style scoped>
    .pdf-document {
        border: 1px solid #aaa;
        border-radius: 2px;
        margin-bottom: 10px;
    }
</style>
